import styled from 'styled-components'
import { Container } from '@material-ui/core'

export const StyledDeliveryManagement = styled(Container)`
	background-color: ${(props) => props.theme.palette.primaryWhite.main};
`
